import React, { useState, useEffect, Fragment, useRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const MaterialRequirement = ({
  data,
  handleValue = null,
  leadId,
  getMaterial,
  getMateriaById,
  handleDataFilter = null,
  handleremoveValue = null,
}) => {
  const objInput = { category_id: '', material_id: '', quantity: '' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);
  const [gateData, setGateData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleData = () => {
    if (data) {
      setGateData(data);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      handleData();
    }
  }, [data]);

  const addGates = () => {
    if (!inputListData1.length && !inputListData2.length) {
      setIsError(true);
      return false;
    }
    setInputValue([
      ...inputValue,
      { category_id: '', material_id: '', quantity: '' },
    ]);
    if (inputListData1?.id) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }

    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
  };
  const removeGate = (index = null) => {
    let removeArray = inputValue.splice(index + 1, 1);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  const handleInitalValue = () => {
    setCatVal('');
    setNumberVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };

  const handleFormData = () => {
    if (inputValue) {
      handleValue(inputValue);
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [inputValue]);

  useEffect(() => {
    if (catVal) {
      (async () => {
        setIsLoading(true);
        await getMateriaById(catVal);
        setIsLoading(false);
      })();
    }
  }, [catVal]);

  useEffect(() => {
    (() => {
      if (getMaterial) {
        setMaterialData(getMaterial);
      }
    })();
  }, [getMaterial]);

  const handleInputValue = (val, key, index) => {
    const list = [...inputValue];
    list[index][key] = val;
    setInputValue([...list]);
  };

  return (
    <Fragment>
      <FormSection
        title={localization.materialRequirement}
        isLoading={isLoading}
      >
        <div className="w-100 row mx-0">
          <div
            ref={inputRef.current[0]}
            className="row mx-0"
            disabled={catVal && numberVal ? true : false}
          >
            <DropDownInput
              label={localization.cat}
              data={gateData}
              getIdValue={(val) => {
                setCatVal(val.id);
                handleInputValue(val.id, 'category_id', 0);
              }}
              errorMsg={localization.isRequired}
              required
              isStarRequired={true}
            />
            {inputValue[0].category_id && (
              <DropDownInput
                label={localization.product}
                data={materialData.length > 0 ? materialData : []}
                getIdValue={(val) => {
                  handleInputValue(val.id, 'material_id', 0);
                }}
                errorMsg={localization.isRequired}
                required
                isStarRequired={true}
              />
            )}

            <ConstantInput
              label={localization.quantity}
              errorMsg={localization.numberError}
              type="number"
              required
              isStarRequired={true}
              handleChange={(val) => {
                setNumberVal(val);
                setInputListData2(val);
                setIsCurrentRef(0);
                handleInputValue(val, 'quantity', 0);
              }}
              min={0}
              regex={Regex.numericNotZero.test(inputValue[0]?.quantity)}
            />

            <div>
              {inputList.length === 0 && catVal && numberVal ? (
                <Fragment>
                  <ButtonWithIcon
                    onClick={handleInitalValue}
                    title={localization.clear}
                  />
                </Fragment>
              ) : null}
            </div>
          </div>
        </div>

        {inputList &&
          inputList.map((item, index) => {
            return (
              <div key={item.id} className="w-100 row mx-0">
                <div className="row mx-0" ref={inputRef.current[index + 1]}>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={gateData}
                    getIdValue={(val) => {
                      setCatVal(val.id);
                      handleInputValue(val.id, 'category_id', index + 1);
                    }}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                  />
                  {inputValue[index + 1].category_id && (
                    <DropDownInput
                      label={localization.selectMaterial}
                      data={materialData}
                      getIdValue={(val) => {
                        handleInputValue(val.id, 'material_id', index + 1);
                      }}
                      errorMsg={localization.isRequired}
                      required
                      isStarRequired={true}
                    />
                  )}

                  <ConstantInput
                    label={localization.quantity}
                    errorMsg={localization.numberError}
                    type="number"
                    required
                    isStarRequired={true}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index + 1);
                      handleInputValue(val, 'quantity', index + 1);
                    }}
                    min={0}
                    regex={Regex.numericNotZero.test(
                      inputValue[index + 1]?.quantity
                    )}
                  />
                  <div>
                    <ButtonWithIcon
                      title="Remove"
                      onClick={() => removeGate(index)}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        <span>
          {isError ? (
            <label className="error d-block">{localization.enterField}</label>
          ) : null}
        </span>
        <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div>
      </FormSection>
    </Fragment>
  );
};

export default MaterialRequirement;
